import { HttpHeaders } from '@angular/common/http';

export class Service {
    public url: string;

    constructor() {
        if(!/localhost/.test(document.location.host))
            this.url = '/api'; // prod
            /*this.url = 'http://curso-anestesiovirtual.com';*/ // prod
        else {
            // test
            /*this.url = 'http://localhost:8000';*/
            this.url = 'http://anestesiovirtual.com/api';
        }
    }

    protected getApiRoute(route: string) {
        return this.url + route;
    }

    get headers() {
        let authToken = localStorage.getItem('auth_token');
        let headers = new HttpHeaders();
            headers = headers.append('Content-Type', 'application/json');
        if (authToken !== null && authToken !== 'undefined') {
            headers = headers.append('Authorization', `Bearer ` + authToken);
        }

        return { headers: headers };
    }
    get headersContact() {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        /*headers = headers.append('responseType', 'text');*/

        return { headers: headers };
    }
 }
